import { ModalBooleanItem } from './ModalBooleanItem';
import { ModalCountryItem } from './ModalCountryItem';
import { ModalDateItem } from './ModalDateItem';
import { ModalDurationItem } from './ModalDurationItem';
import { ModalEditorItemBase } from './ModalEditorItemBase';
import { ModalEnumItem } from './ModalEnumItem';
import { ModalGenderItem } from './ModalGenderItem';
import { ModalIdItem } from './ModalIdItem';
import { ModalImageItem } from './ModalImageItem';
import { ModalMultiSelectItem } from './ModalMultiSelectItem';
import { ModalNumberItem } from './ModalNumberItem';
import { ModalPasswordItem } from './ModalPasswordItem';
import { ModalSelectItem } from './ModalSelectItem';
import { ModalTextItem } from './ModalTextItem';
import { ModalTimeZoneItem } from './ModalTimeZoneItem';

export const ModalEditorItem = Object.assign(ModalEditorItemBase, {
    Duration: ModalDurationItem,
    Text: ModalTextItem,
    Country: ModalCountryItem,
    Date: ModalDateItem,
    Gender: ModalGenderItem,
    Image: ModalImageItem,
    Boolean: ModalBooleanItem,
    Id: ModalIdItem,
    MultiSelect: ModalMultiSelectItem,
    Number: ModalNumberItem,
    TimeZone: ModalTimeZoneItem,
    Select: ModalSelectItem,
    Enum: ModalEnumItem,
    Password: ModalPasswordItem,
});
